import { Box, Flex } from '@chakra-ui/react';

import styles from './styles.module.css';
import SkeletonComponent from 'UiKit/skeleton';

const BreakModalSkeleton = () => {
  return (
    <Box className={styles['break-modal__container']}>
      <Flex className={styles['break-modal__section--head']}>
        <SkeletonComponent height="100px" width="100px" borderRadius="50% !important" />
      </Flex>

      <Flex className={styles['break-modal__section--content']}>
        <SkeletonComponent height="26px" width="114px" mb="14px" />
        <SkeletonComponent height="22px" width="90%" mb="14px" />
        <SkeletonComponent height="28px" width="110px" m="12px 0" />
      </Flex>

      <Flex className={styles['break-modal__section--footer']}>
        <SkeletonComponent height="40px" width="176px" />
      </Flex>
    </Box>
  );
};

export default BreakModalSkeleton;
